export default {
  cancel: 'Cancel',
}
